<template>
  <div class="row details__actions no-gutters">
    <div class="col-md-5 col-lg-4 col-xl-3">
      <p class="headings--h4"> {{ I18n.t("artworks.starting_price_label") }} </p>
      <p v-if="artwork.startingPrice > 0" class="price--highlight">
        {{ I18n.t("artworks.price", { price: formatPrice(artwork.startingPrice) }) }}
        <span v-if="artwork.droitDeSuite" class="price price--plus-droit-de-suite">
          {{ I18n.t("artworks.droit_de_suite") }}
        </span>
      </p>
      <p v-else>
        <span class="price--info" v-b-tooltip.hover.topright :title="I18n.t('artworks.no_starting_price_info')"></span>
        <span v-if="artwork.droitDeSuite" class="price price--plus-droit-de-suite">
          {{ I18n.t("artworks.droit_de_suite") }}
        </span>
      </p>
    </div>
    <div class="col-md-5 col-lg-4">
      <p v-if="estimationsProvided" class="headings--h4">
        {{ I18n.t("artworks.estimation_label") }}
      </p>
      <p v-if="estimationsProvided">
        {{ I18n.t("artworks.estimated_prices_with_currency",
        { price_min: formatPrice(artwork.estimationMin),
          price_max: formatPrice(artwork.estimationMax) }) }}
      </p>
    </div>
    <OrderDetails :artwork="artwork" :index="index" />
  </div>
</template>

<script>
  import { formatNumber } from '@/shared/helpers';
  import OrderDetails from './order_details';

  export default {
    name: 'IncomingArtworkPriceDetails',
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    components: {
      OrderDetails,
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    computed: {
      estimationsProvided() {
        return this.artwork.estimationMin && this.artwork.estimationMax;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/incoming_artwork_price_details.vue?33aeeeb4